import React, { useRef } from "react";
import { useDispatch } from "react-redux";
import styles from "../../auth/auth.module.css";
import { hideModal } from '../../../redux/action';
import XCloseIcon from "../../../images/svg/xCloseIcon";
import { useOutsideClick } from '../../../hooks/useClickOutside';


const AuthModal = ({ children, isSignup }) => {
  const dispatch = useDispatch();
  

  const modalRef = useRef();

  const handleClose = () => dispatch(hideModal());

  useOutsideClick(modalRef, handleClose);

  return (
    <section className={styles["authModalOverlay"]}>
      <div
        className={`${styles["authModalShell"]} ${
          isSignup ? styles["authModalShellSignup"] : ""
        }`}
        ref={modalRef}
      >
        <button
          type="button"
          className={styles["authModalCloseButton"]}
          onClick={handleClose}
          aria-label="Close authentication modal"
        >
          <XCloseIcon fill="white" />
        </button>
        {children}
      </div>
    </section>
  );
};

export default AuthModal;
